import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Theme } from "@mui/material/styles";
import { memo } from "react";

import { colors } from "@/theme";

import { CLOUD_HEIGHT, CLOUD_PATH, CLOUD_PING_COUNT, CLOUD_PING_CYCLE, CLOUD_WIDTH } from "./data";

/**
 * One cloud drifting outward from the mark.
 *
 * Three of them on the same cycle, a third of it apart, so the wait reads as
 * weather moving past rather than as a spinner going round.
 */
const CloudPing = memo(({ index }: { index: number }) => (
  <svg
    className="cloud-ping"
    viewBox={`0 0 ${CLOUD_WIDTH} ${CLOUD_HEIGHT}`}
    style={{ animationDelay: `${(index * CLOUD_PING_CYCLE) / CLOUD_PING_COUNT}s` }}
  >
    <path d={CLOUD_PATH} fill="none" stroke={colors.prime} strokeWidth="2" strokeLinejoin="round" />
  </svg>
));

CloudPing.displayName = "CloudPing";

const containerStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  p: 3,
  zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
};

const innerContainerStyles = {
  maxWidth: 500,
  width: "100%",
  my: 5,
};

const loadingBoxStyles = {
  position: "relative",
  pt: 20,
  width: "100%",
};

export const SkyLoading = () => {
  return (
    <Box className="loading" sx={loadingBoxStyles}>
      <Box className="cloud-group">
        {Array.from({ length: CLOUD_PING_COUNT }).map((_, index) => (
          <CloudPing key={`cloud-ping-${index}`} index={index} />
        ))}
        {/* <Box className="cloud-core" /> */}
      </Box>
    </Box>
  );
};

const LoadingFallback = memo(() => {
  return (
    <Stack sx={containerStyles} alignItems="center" justifyContent="center">
      <Stack
        sx={innerContainerStyles}
        alignItems="center"
        justifyContent="center"
        gap={1}
        textAlign="center"
      >
        <SkyLoading />
      </Stack>
    </Stack>
  );
});
LoadingFallback.displayName = "LoadingFallback";

export default LoadingFallback;
